import { z } from "zod";

export const sectionItemTypeEnum = z.enum([
  "small",
  "medium",
  "large",
  "moodcheck",
  "daily_quote",
  "trivia",
  "trivia_leaderboard",
  "hallow_plus_banner",
  "create_group",
  "invite_to_group",
  "alerts",
  "prayer_goal_row",
  "prayer_goal",
  "suggested_routine",
  "deeplink_card",
  "deeplink_card_condensed",
  "deeplink_card_medium",
  "deeplink_card_small",
  "deeplink_card_playable",
  "player_card",
  "campaign",
  "create_campaign_prompt",
  "create_campaign_prompt_v2_final",
  "magisterium_prompt",
  "streak", // streak section on me page
  "text_summary", // intentions and reflections sections on me page
  "games",
  "the_word",
]);

export type SectionItemType = z.infer<typeof sectionItemTypeEnum>;
